import FileUpload from '~/scripts/services/model/file-upload';

/**
 * @param {import('angular').auto.IInjectorService} $injector
 * @param {any} $scope
 */
export default /* @ngInject */ (
	$injector,
	$scope,
) => {
	$scope.$watch('kform', (/** @type {import('~/components/kform/kform.controller').default | undefined} */ kform) => {
		if (kform && $scope.kform?.currentKid) {
			if (!($scope.component.key in $scope.kform.forms[$scope.kform.currentKid].uploadFiles)) {
				$scope.kform.forms[$scope.kform.currentKid].uploadFiles[$scope.component.key] = [];
			}
			$scope.uploadFiles = $scope.kform.forms[$scope.kform.currentKid].uploadFiles[$scope.component.key];
		}
	});


	/**
	 * @param {File[]} files
	 */
	$scope.addFiles = files => {
		$scope.uploadFiles.push(...files.map(file => new FileUpload($injector, file, file.name)));
		$scope.kform.forms[$scope.kform.currentKid].formScope?.kformForm?.$setDirty();
	}

	/**
	 * @param {number} k
	 */
	$scope.removeFile = k => {
		$scope.uploadFiles.splice(k, 1);
		$scope.kform.forms[$scope.kform.currentKid].formScope?.kformForm?.$setDirty();
	};
};
